export default {
    REST_API_BASE_URL: process.env.VUE_APP_REST_API_BASE_URL,
    BASE_URL: process.env.VUE_APP_REST_API_BASE_URL.substring(0, process.env.VUE_APP_REST_API_BASE_URL.length - 5),
    BASE_URL_WEBSOCKET: process.env.VUE_APP_WEBSOCKET_BASE_URL,
    VUE_APP_BASE_URL: process.env.VUE_APP_BASE_URL,
    stompClient: null,
    socketHeartBeatStatus: { editModeEnabled: false, focussedFieldId: null, username: null, activePageUrl: null, tabId: null, entityId: null },
};
